export default function Configure($stateProvider) {
    $stateProvider.state('societes-laboratoire', {
        parent: 'common',
        url: '/societes-laboratoire',
        views: {
            common: {
                template: '<ui-view></ui-view>'
            }
        },
        ncyBreadcrumb: {
            label: '{{ "LAYOUT.NAVIGATION.DONNEES_PARAMETRES" | translate }}'
        }
    });

    $stateProvider.state('societes-laboratoire.list', {
        url: '/list',
        template: '<societes></societes>',
        rights: { domain: 'societes', right: 'read', application: 'laboratoire' },
        params: {
            genre: '32'
        },
        ncyBreadcrumb: {
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETES_LABORATOIRE_LIST" | translate}}'
        },
        navigation: {
            menu: 'donnees_parametres_donnees',
            translate: 'SOCIETES.BREADCRUMBS.SOCIETES_LABORATOIRE_LIST',
            order: 1
        },
        search: 'SOCIETES.BREADCRUMBS.SOCIETES_LABORATOIRE_LIST'
    });

    $stateProvider.state('societes-laboratoire.niveaux', {
        url: '/niveaux',
        template: '<societe-config-niveaux></societe-config-niveaux>',
        rights: { domain: 'nivh', right: 'read' },
        params: {
            genre: '32'
        },
        ncyBreadcrumb: {
            // on décide que la liste est le parent des autres states
            // afin d'afficher societes > niveaux
            parent: 'societes-laboratoire.list({genre: "32"})',
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETE_NIVEAUX" | translate }}'
        }
    });

    $stateProvider.state('societes-laboratoire.list.detail', {
        url: '/{id}',
        template: '<societe-detail></societe-detail>',
        rights: { domain: 'societes', right: 'read' },
        params: {
            genre: '32'
        },
        ncyBreadcrumb: {
            parent: 'societes-laboratoire.list({genre: "32"})',
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETE_DETAIL" | translate }}'
        }
    });

    $stateProvider.state('societes-laboratoire.new', {
        url: '/new',
        template: '<societe-form></societe-form>',
        rights: { domain: 'societes', right: 'create' },
        params: {
            genre: '32'
        },
        ncyBreadcrumb: {
            parent: 'societes-laboratoire.list({genre: "32"})',
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETE_LABORATOIRE_NEW" | translate}}'
        },
        search: 'SOCIETES.BREADCRUMBS.SOCIETE_LABORATOIRE_NEW'
    });

    $stateProvider.state('societes-laboratoire.edit', {
        url: '/{id}/edit',
        template: '<societe-form></societe-form>',
        rights: { domain: 'societes', right: 'update' },
        params: {
            genre: '32'
        },
        ncyBreadcrumb: {
            parent: 'societes-laboratoire.list({genre: "32"})',
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETE_LABORATOIRE_EDIT" | translate }}'
        }
    });

    $stateProvider.state('societes-laboratoire.newType', {
        url: '/new-type',
        template: '<type-form></type-form>',
        rights: { domain: 'types', right: 'create' },
        params: {
            parentState: 'societes-laboratoire.new',
            genre: '32'
        },
        ncyBreadcrumb: {
            parent: 'societes-laboratoire.new',
            label: '{{ "TYPES.BREADCRUMBS.TYPE_NEW" | translate}}'
        }
    });
}

Configure.$inject = ['$stateProvider'];
